import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { COLORS, RADIUS, FONTS } from "../theme";

const AlertPopup = ({ open, onClose, title, message }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          background: COLORS.gray,
          color: COLORS.white,
          borderRadius: RADIUS.card,
          border: "1px solid rgba(255,255,255,0.08)",
          minWidth: { xs: "auto", sm: "380px" },
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ fontFamily: FONTS.heading, color: COLORS.white }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: "rgba(255,255,255,0.7)" }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          autoFocus
          sx={{
            borderRadius: RADIUS.pill,
            background: COLORS.peach,
            color: COLORS.dark,
            fontWeight: 700,
            px: 3,
            "&:hover": { background: COLORS.gold },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertPopup;